"use client";

import { ChaosEvent } from "@/lib/chaosEngine";

interface ChaosEffectsPanelProps {
  // Every Buff / Nerf the chaos wheel has landed on so far this run.
  effects: ChaosEvent[];
}

// A running tally of the buffs and nerfs picked up from the chaos wheel,
// pinned to the left of the main wheel. It's fixed-positioned so it never
// shifts the wheel, and it persists for the whole run. Hidden on smaller
// screens where there's no room beside the wheel.
export default function ChaosEffectsPanel({ effects }: ChaosEffectsPanelProps) {
  if (effects.length === 0) return null;

  return (
    <div className="fixed left-3 top-1/2 z-30 hidden max-h-[78vh] w-[min(14rem,17vw)] -translate-y-1/2 flex-col gap-2 overflow-y-auto lg:flex">
      <div className="text-[0.6rem] font-bold uppercase tracking-[0.3em] text-yellow-300/80">
        Chaos Effects
      </div>
      {effects.map((e, i) => {
        const isBuff = e.type === "Buff";
        return (
          <div
            key={i}
            className={`rounded-xl border px-3 py-2 backdrop-blur ${
              isBuff
                ? "border-green-400/40 bg-green-400/10"
                : "border-red-400/40 bg-red-400/10"
            }`}
          >
            <div className="flex items-start gap-2">
              <span
                className={`mt-px font-mono text-base font-black leading-none ${
                  isBuff ? "text-green-400" : "text-red-400"
                }`}
                aria-hidden
              >
                {isBuff ? "+" : "−"}
              </span>
              <div className="min-w-0">
                <div className="text-xs font-bold leading-tight text-white">
                  {e.result}
                </div>
                {e.pointImpact !== 0 ? (
                  <div
                    className={`mt-0.5 font-mono text-[0.7rem] font-bold ${
                      isBuff ? "text-green-400" : "text-red-400"
                    }`}
                  >
                    {e.pointImpact > 0 ? "+" : ""}
                    {e.pointImpact.toLocaleString()}
                  </div>
                ) : (
                  <div className="mt-0.5 text-[0.6rem] uppercase tracking-widest text-white/40">
                    {e.pending ? "Pending" : isBuff ? "Buff" : "Nerf"}
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
